export const cacheSize = 5;

export const cacheKey = 'recent-projects';
